import React, { useState } from 'react'
import { Form, Input, message } from 'antd'
import BlueButton from '../../components/shared/BlueButton';
import AuthLayout from './authLayout';
import { Link, useNavigate } from 'react-router-dom';
import { registerCompany } from '../../api/auth';


export default function CompanyRegistration() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await registerCompany(values);
            if (res.Code === 1) {
                message.success("Verification link sent to your email");
                form.resetFields();
                navigate("/");
            } else {
                message.error(res.Data?.message || "Something went wrong, please try again later");
            }
        } catch (error) {
            console.log(error);
            message.error("Something went wrong, please try again later");
        }
        setLoading(false);
    }

    return (
        <AuthLayout>
            <section >
                <Form form={form} layout='vertical' onFinish={onFinish}>
                    <Form.Item name="name" label="Company Name" rules={[{ required: true }]} ><Input className='rounded-none' /></Form.Item>
                    <Form.Item name="email" label="Email" rules={[{ required: true }]} ><Input type='email' className='rounded-none' /></Form.Item>
                    <Form.Item name="contactName" label="Contact Person" rules={[{ required: true }]} ><Input className='rounded-none' /></Form.Item>
                    <Form.Item name="contactNumber" label="Phone Number" rules={[{ required: true }]} ><Input className='rounded-none' /></Form.Item>
                    <Form.Item className='flex justify-center'>
                        <BlueButton type="primary" className="rounded-none" htmlType="submit" disabled={loading} >Register Company</BlueButton>
                    </Form.Item>
                </Form>
            </section>

            <p className='text-center text-[#A0A0A0]'>Already have an account? <Link to="/login">Sign In</Link></p>
        </AuthLayout>
    )
}
